<template>
  <AppModalEdit
    @cancel="closeModal"
    @clickExec="onSubmit"
    :value="value"
    title="地点グループのコピー"
    exec-button-text="コピー"
    width="48vw"
    min-height="12vh"
  >
    <v-form ref="form" v-model="valid" @submit.prevent>
      <v-text-field
        v-if="value"
        v-model="newLocationGroupName"
        :rules="[rules.required, rules.max]"
        @keypress.enter="onSubmit"
        autofocus
        hint="新規で作成するグループ名を入力してください"
      />
    </v-form>
  </AppModalEdit>
</template>

<script>
import { SimulationLocationGroup } from '@/models/Simulation'
import { snackbarType } from '@/vuex/modules/ui/snackbar/constants'
import { mapActions } from 'vuex'

export default {
  name: 'SimulationContentDeliveryLocationGroupCopyModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    simulationLocationGroups: {
      type: Object,
      default: () => {},
    },
    groupId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      valid: false,
      newLocationGroupName: '',
    }
  },
  computed: {
    rules() {
      return SimulationLocationGroup.validations
    },
  },
  methods: {
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    closeModal() {
      this.newLocationGroupName = ''
      this.$emit('input', false)
    },
    onSubmit() {
      if (!this.$refs.form.validate()) {
        return false
      }
      this.simulationLocationGroups.copyGroup(
        this.groupId,
        this.newLocationGroupName,
      )

      this.showSnackbar({
        type: snackbarType.SUCCESS,
        message: '地点グループをコピーしました',
      })

      this.closeModal()
    },
  },
}
</script>

<style scoped></style>
